import { Box, Stack, Typography, Button } from "@mui/joy";
import { ArrowBackIos, CalendarToday } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { HEADER_HEIGHT } from "components/common/Layout";

interface EmployerCandidateListHeaderProps {
  handleBackToCandidates: () => void;
  handleSchedule: () => void;
}

const CandidateListHeader: React.FC<EmployerCandidateListHeaderProps> = ({
  handleBackToCandidates,
  handleSchedule,
}) => {
  
  return (
    <Box
      data-header-sticky
      sx={{
        position: 'sticky',
        top: HEADER_HEIGHT,
        left: 0,
        right: 0,
        zIndex: 10,
        background: 'linear-gradient(to bottom, rgba(244, 244, 244, 1.0) 0%, rgba(244, 244, 244, 1.0) 50%, rgba(244, 244, 244, 0.0) 100%)',
        my: 4,
        py: 2,
      }}
    >
      <Stack
        direction="column"
        spacing={2}
        sx={{
          py: 2,
          px: 4,
          backgroundColor: 'white',
          borderRadius: '16px',
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button variant="plain" onClick={handleBackToCandidates} sx={{ pl: 2, pr: 1, color: "black" }}>
            <ArrowBackIos sx={{ width: 24, height: 24 }} />
          </Button>
          <Typography level="h3" sx={{ flex: 1 }}>
            Selected People
          </Typography>
          <Button 
            variant="solid" 
            size="sm" 
            startDecorator={<CalendarToday />}
            sx={{
              display: { xs: 'none', md: 'inherit' },
              backgroundColor: '#2e2d7e',
              '&:hover': { backgroundColor: '#1e1d6e' }
            }}
            onClick={handleSchedule}
          >
            Schedule Meeting
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CandidateListHeader; 